import { createAction, props } from '@ngrx/store';
import { ImpersonationStopReason } from '../impersonation.constants';
import { ImpersonationActionLogRequest, ImpersonationRequestMetadata } from '../models/impersonation-action-log.model';

export const initializeImpersonation = createAction('[Impersonation] Initialize', props<{ targetUserId: number }>());

export const stopImpersonation = createAction(
  '[Impersonation] Stop Impersonation',
  props<{ reason?: ImpersonationStopReason }>()
);

export const setImpersonationSuccess = createAction(
  '[Impersonation] Set Impersonation Success',
  props<{
    accessExpiresDateTime: string | null;
    accessScope: string[] | null;
    userImpersonationAuthId: number;
    originalUserId: number;
  }>()
);

export const setImpersonationFailed = createAction(
  '[Impersonation] Set Impersonation Failed',
  props<{ reason: ImpersonationStopReason }>()
);

export const logImpersonationAction = createAction(
  '[Impersonation] Log Action',
  props<{ request: ImpersonationActionLogRequest }>()
);

export const trackImpersonationRequest = createAction(
  '[Impersonation] Track Request',
  props<ImpersonationRequestMetadata & { statusCode: number }>()
);
